export const API_CALL_LIST = 'API_CALL_LIST';
export const API_CALL_CLEAR = 'API_CALL_CLEAR';

export const API_CALL_LOGS_LIST = 'API_CALL_LOGS_LIST';
export const API_CALL_LOGS_CLEAR = 'API_CALL_LOGS_CLEAR';